import { toNote } from '@/lib/link'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useTranslation } from 'react-i18next'
import Content from './Content'

export default function PollPreview({ event, className }: { event: Event; className?: string }) {
  const { t } = useTranslation()

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Poll')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()}>
        <Content event={event} className="italic pr-0.5" />
      </a>
    </div>
  )
}
